// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.appointment-main{
padding-left: 20px;
padding-right: 20px;
font-family: 'GT-Walsheim'

}
.upper-text{
font-size: 20px;
font-weight: 700;
color: #101925;
margin-top: 32px;
font-family: 'GT-Walsheim-Bold'


}
.appointment-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  font-family: 'GT-Walsheim'

}

.sub-header{
  font-family: 'GT-Walsheim';
  font-size: 16px;
    line-height: 16px;
    font-weight: 700;
    color: #101925;
}


.custom-scrollbar::-webkit-scrollbar {
    display: none; /* Hide scrollbar for Chrome, Safari, and Edge */
  }
  
  .custom-scrollbar {
    -ms-overflow-style: none;  /* Hide scrollbar for IE and Edge */
    scrollbar-width: none;  /* Hide scrollbar for Firefox */
  }

  .custom-row-gap {
    display: flex;
    flex-wrap: wrap;
    row-gap: 5px;  /* Minimal gap between rows */
  
  }
  
  .custom-col {
    padding: 1px !important;  /* Remove extra spacing */
    margin: 0 !important;
  }
  
  .ReportCard {
    margin: 0 !important;  /* Ensure ReportCard itself has no margins */
    padding: 5px !important; /* Add small padding if needed */
    font-family: 'GT-Walsheim'

  }
  
  .menu-heading{
    display: flex;
    justify-content: space-between;
    padding: 10px;
    font-size: 18px;
    font-weight: 500;
    padding-left: 23px;
    font-family: 'GT-Walsheim'

  }

  .sticky-header {
    position: sticky;
    top: 0;
    z-index: 1020; /* Ensure it stays on top */
    background-color: white; /* Prevent transparency */
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); /* Optional shadow */
    font-family: 'GT-Walsheim'

  }
  


  @media (max-width: 576px) { /* Mobile View */
    .custom-row-gap {
      justify-content: center;
      text-align: center;
    }
  }`, "",{"version":3,"sources":["webpack://./src/Screens/myappointment.css"],"names":[],"mappings":"AAAA;AACA,kBAAkB;AAClB,mBAAmB;AACnB;;AAEA;AACA;AACA,eAAe;AACf,gBAAgB;AAChB,cAAc;AACd,gBAAgB;AAChB;;;AAGA;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb;;AAEF;;AAEA;EACE,0BAA0B;EAC1B,eAAe;IACb,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;;AAGA;IACI,aAAa,EAAE,gDAAgD;EACjE;;EAEA;IACE,wBAAwB,GAAG,mCAAmC;IAC9D,qBAAqB,GAAG,+BAA+B;EACzD;;EAEA;IACE,aAAa;IACb,eAAe;IACf,YAAY,GAAG,6BAA6B;;EAE9C;;EAEA;IACE,uBAAuB,GAAG,yBAAyB;IACnD,oBAAoB;EACtB;;EAEA;IACE,oBAAoB,GAAG,4CAA4C;IACnE,uBAAuB,EAAE,gCAAgC;IACzD;;EAEF;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB;;EAEF;;EAEA;IACE,gBAAgB;IAChB,MAAM;IACN,aAAa,EAAE,2BAA2B;IAC1C,uBAAuB,EAAE,yBAAyB;IAClD,wCAAwC,EAAE,oBAAoB;IAC9D;;EAEF;;;;EAIA,4BAA4B,gBAAgB;IAC1C;MACE,uBAAuB;MACvB,kBAAkB;IACpB;EACF","sourcesContent":[".appointment-main{\npadding-left: 20px;\npadding-right: 20px;\nfont-family: 'GT-Walsheim'\n\n}\n.upper-text{\nfont-size: 20px;\nfont-weight: 700;\ncolor: #101925;\nmargin-top: 32px;\nfont-family: 'GT-Walsheim-Bold'\n\n\n}\n.appointment-container {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  font-family: 'GT-Walsheim'\n\n}\n\n.sub-header{\n  font-family: 'GT-Walsheim';\n  font-size: 16px;\n    line-height: 16px;\n    font-weight: 700;\n    color: #101925;\n}\n\n\n.custom-scrollbar::-webkit-scrollbar {\n    display: none; /* Hide scrollbar for Chrome, Safari, and Edge */\n  }\n  \n  .custom-scrollbar {\n    -ms-overflow-style: none;  /* Hide scrollbar for IE and Edge */\n    scrollbar-width: none;  /* Hide scrollbar for Firefox */\n  }\n\n  .custom-row-gap {\n    display: flex;\n    flex-wrap: wrap;\n    row-gap: 5px;  /* Minimal gap between rows */\n  \n  }\n  \n  .custom-col {\n    padding: 1px !important;  /* Remove extra spacing */\n    margin: 0 !important;\n  }\n  \n  .ReportCard {\n    margin: 0 !important;  /* Ensure ReportCard itself has no margins */\n    padding: 5px !important; /* Add small padding if needed */\n    font-family: 'GT-Walsheim'\n\n  }\n  \n  .menu-heading{\n    display: flex;\n    justify-content: space-between;\n    padding: 10px;\n    font-size: 18px;\n    font-weight: 500;\n    padding-left: 23px;\n    font-family: 'GT-Walsheim'\n\n  }\n\n  .sticky-header {\n    position: sticky;\n    top: 0;\n    z-index: 1020; /* Ensure it stays on top */\n    background-color: white; /* Prevent transparency */\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); /* Optional shadow */\n    font-family: 'GT-Walsheim'\n\n  }\n  \n\n\n  @media (max-width: 576px) { /* Mobile View */\n    .custom-row-gap {\n      justify-content: center;\n      text-align: center;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
